/** @format */

import { useCallback, useState } from "react";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { FiMenu } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { ROUTES } from "src/constants";
import { useCurrentPatientRedux } from "src/hooks/patients/useLobbiePatient";
import { useLogoutUser } from "src/hooks/user";
import { noop } from "src/utils";

const PatientHeader = () => {
    const { replace } = useHistory();
    const [logout] = useLogoutUser();
    const user = useCurrentPatientRedux();

    const [expanded, setExpanded] = useState<boolean>(false);

    const handleNavigateReplace = useCallback(
        (route: string, params?: Record<string, any>) => {
            setExpanded(false);
            if (params) {
                replace(route, params);
            } else {
                replace(route);
            }
        },
        [replace],
    );

    const handleSetExpanded = useCallback(() => setExpanded((current) => !current), []);
    const handleNavigateToPatientHome = useCallback(
        () => handleNavigateReplace(ROUTES.patientHome),
        [handleNavigateReplace],
    );
    const handleNavigateToPatientProfile = useCallback(
        () => handleNavigateReplace(ROUTES.patientProfile),
        [handleNavigateReplace],
    );

    if (!user) return null;

    return (
        <Navbar bg="white" expand="md" className={"border-0"} expanded={expanded}>
            {!user?.activated ? (
                <>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        className="border-0"
                        onClick={noop}
                    >
                        &nbsp;
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto pl-3"></Nav>
                    </Navbar.Collapse>
                </>
            ) : (
                <>
                    <Navbar.Toggle
                        aria-controls="basic-navbar-nav"
                        className="border-0"
                        onClick={handleSetExpanded}
                    >
                        <FiMenu />
                    </Navbar.Toggle>
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav className="ml-auto pl-3">
                            <Nav.Link onClick={handleNavigateToPatientHome}>Dashboard</Nav.Link>

                            <Nav.Link eventKey="4.1" onClick={handleNavigateToPatientProfile}>
                                Profile
                            </Nav.Link>
                            <Nav.Link eventKey="4.2" onClick={logout}>
                                Logout
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </>
            )}
        </Navbar>
    );
};

export default PatientHeader;
